export function numberWithComma(number = 0, n_digits = 3) {
  return number.toString().replace(new RegExp('\\B(?<!\\.\\d*)(?=(\\d{' + n_digits + '})+(?!\\d))', 'g'), ",");
}

export function lerp(x, y, a) {
  return x * (1 - a) + y * a;
}

export function ease(x, y, t) {
  const a = t > 0.5 ? 4 * Math.pow((t - 1), 3) + 1 : 4 * Math.pow(t, 3);
  return x * (1 - a) + y * a;
}